import React from 'react';

import Button from '../../../../../../../../common/general/Button';
import Icon from '../../../../../../../../common/general/Icon';
import { confirmWhenConditionalLogicAffected } from '../../../../../services/conditionalLogicUtils';
import { getFormattedSubElementName } from '../../../itemGroupSetupService';

import { CustomFieldBlock } from './CustomFieldBlock';

export function CustomFieldLabelClosableBlock({
  terminologyVersionGroupNumber,
  editMode,
  customFieldData,
  domain,
  labelIndex,
  getCheckboxForTableView,
  inputs,
  updateInputsAndPreviewData,
  getInvestigatorFieldCheckboxForTableView,
  getExpenseFixedICheckboxForTableView,
  updateState,
  onChangeLabelTextHandler,
  columnsToShow,
  onFinanceFieldChange
}) {
  customFieldData.itemDefinitionList = []; // Don't know why it is in code, but it was.
  const isCustomFieldsExist = customFieldData && customFieldData.customItemDefinationList;

  return (
    <div className="igs-grid-row-inner igs-grid-row-inner-custom-fields custom-item">
      {customFieldData.formLabelName && (
        <div className="igs-grid-row-inner-custom-fields-header">
          <label className="vital-label-heading">{getFormattedSubElementName(customFieldData.formLabelName)}</label>
        </div>
      )}
      {isCustomFieldsExist && (
        <CustomFieldBlock
          editMode={editMode}
          terminologyVersionGroupNumber={terminologyVersionGroupNumber}
          customFieldData={customFieldData}
          domain={domain}
          labelIndex={labelIndex}
          getCheckboxForTableView={getCheckboxForTableView}
          getInvestigatorFieldCheckboxForTableView={getInvestigatorFieldCheckboxForTableView}
          getExpenseFixedCheckboxForTableView={getExpenseFixedICheckboxForTableView}
          inputs={inputs}
          updateInputsAndPreviewData={updateInputsAndPreviewData}
          updateState={updateState}
          onChangeLabelTextHandler={onChangeLabelTextHandler}
          columnsToShow={columnsToShow}
          onFinanceFieldChange={onFinanceFieldChange}
        />
      )}
      <span className="custom-close">
        <Button size="h28" priority="low" type="button" onClick={() => onCloseFormLabel(labelIndex)}>
          <Icon>clear</Icon>
        </Button>
      </span>
    </div>
  );
  function onCloseFormLabel(labelIndex) {
    if (labelIndex > -1) {
      const currentCustomFieldSequence = inputs[0].custom[labelIndex].customItemDefinationList[0].sequence;
      const customItemsWhichUsesCurrentFieldInConfiguration = inputs[0]?.custom.flatMap(
        e => e.customItemDefinationList
      );
      const allItemsWhichUsesCurrentFieldInConfiguration = [
        ...inputs[0]?.optional[0]?.itemDefinitionList,
        ...customItemsWhichUsesCurrentFieldInConfiguration
      ]
        .filter(e => !!e.fieldConfigurationResponse)
        .filter(e => resolveFieldSequence(e.fieldConfigurationResponse) === currentCustomFieldSequence);

      confirmWhenConditionalLogicAffected({
        message: 'Deleting this condition field will remove field configurations in this Item Group. Delete anyway?',
        isAffects: allItemsWhichUsesCurrentFieldInConfiguration.length > 0
      }).then(function({ isAffects }) {
        inputs && inputs[0].custom.splice(labelIndex, 1);
        if (isAffects) {
          allItemsWhichUsesCurrentFieldInConfiguration.forEach(item => (item.fieldConfigurationResponse = null));
        }
        updateInputsAndPreviewData(inputs);
      });
    }
  }
}

function resolveFieldSequence(fieldConfigurationResponse) {
  return fieldConfigurationResponse.conditionFieldSequence || fieldConfigurationResponse.conditionField.sequence;
}
